import React, {useState, useEffect, useMemo} from 'react';
import { useIntroPage } from '../IntroPageProvider';
import VideoPlayer from './videoPlayer/VideoPlayer';
import Progress from '../progress/progress';
import {useHistory, useRouteMatch} from 'react-router-dom';
import './index.scss';
import {INTRO_PAGES} from "../intro-page";
import {PAGES} from "../../../constants/routes";
import StoriesProduct from '../../../components/strories-product/StoriesProduct';

export default function IntroVideo({ onVideoEnds, isAppDisplayed }) {
    const history = useHistory();
    const { path } = useRouteMatch();
    const {
        shopVideosStates,
        setPlayingVideoIndex,
        playList,
        stateChecked,
        setStateChecked,
        isShopVideoStatesRefreshed,
        isVideoBuffering,
        playingVideoIndex,
        autoplayPermissionsDenied
    } = useIntroPage();
    const [progressAnimateDuration, setProgressAnimateDuration] = useState(null);
    const [currentTime, setCurrentTime] = useState(0);
    const onDurationChange = (animationData) => {
        setProgressAnimateDuration(animationData)
    }

    const storyConfig = useMemo(() => (
        playList[playingVideoIndex]
    ), [playList, playingVideoIndex])

    const handleAnimation = (index) => {
        if (index === playingVideoIndex && !autoplayPermissionsDenied) {
            return !isVideoBuffering;
        } else {
            return false;
        }
    }

    const stopIntroVideo = () => {
        const videoPlayer = document.getElementById('intro-video-player');
        if (videoPlayer && videoPlayer?.playing && !isAppDisplayed) {
            videoPlayer.pause();
            videoPlayer.currentTime = 0;
        }
    }

    useEffect(() => {
        return () => stopIntroVideo();
    },[])

    useEffect(() => {
        if (shopVideosStates.length > 0 && isShopVideoStatesRefreshed) {
            const isPrevWelcome = history.entries && history.entries.length > 2 && history.entries[history.entries.length - 2].pathname === `${PAGES.INTRO}/${INTRO_PAGES.INTRO_WELCOME}`
            if (isPrevWelcome) {
                if (shopVideosStates.every(item => item.isPlayed)) {
                    setPlayingVideoIndex(playList.length - 1)
                } else {
                    const reversedPlaylist = shopVideosStates.reverse()
                    const index = reversedPlaylist.findIndex(video => video.isPlayed);
                    setPlayingVideoIndex(index - 1);
                }
            } else {
                if (shopVideosStates.every(item => item.isPlayed)) {
                    history.push(`${path}/${INTRO_PAGES.INTRO_WELCOME}`)
                } else {
                    const index = shopVideosStates.findIndex(video => video.isPlayed === false);
                    setPlayingVideoIndex(index);
                }
            }
            setStateChecked(true);
        }
    }, [playList])

    return (
        <>
            {stateChecked && <div className='intro-video-wrapper'>
                <VideoPlayer
                    playListEnded={onVideoEnds}
                    duration={(data) => onDurationChange(data)}
                    onChangeCurrentTime={setCurrentTime}
                />
                {storyConfig?.products?.map((product, index) => (
                    <StoriesProduct
                        key={index}
                        product={product}
                        currentTime={currentTime}
                    />
                ))}
                <div className='progressbar-container'>
                    {playList.map((video, index) => {
                        return (
                            <Progress
                                key={index}
                                index={index}
                                isProgressVisible={handleAnimation(index)}
                                progressAnimateDuration={progressAnimateDuration}
                            />)
                    })}
                </div>
            </div>}
        </>
    )
}
